import { render, staticRenderFns } from "./help-center.html?vue&type=template&id=58ea9ec2&"
import script from "./help-center.js?vue&type=script&lang=js&"
export * from "./help-center.js?vue&type=script&lang=js&"
import style0 from "./help-center.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ea9ec2')) {
      api.createRecord('58ea9ec2', component.options)
    } else {
      api.reload('58ea9ec2', component.options)
    }
    module.hot.accept("./help-center.html?vue&type=template&id=58ea9ec2&", function () {
      api.rerender('58ea9ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/easycash-indo/webview/help-center/help-center.vue"
export default component.exports